import { render, staticRenderFns } from "./ProductionPerformance.vue?vue&type=template&id=71241023"
import script from "./ProductionPerformance.vue?vue&type=script&lang=js"
export * from "./ProductionPerformance.vue?vue&type=script&lang=js"
import style0 from "./ProductionPerformance.vue?vue&type=style&index=0&id=71241023&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports